// import Observer from '@researchgate/react-intersection-observer';
import { compose, lifecycle, pure, withHandlers, withState } from "recompose";

import React from "react";
import Spinner from "../Spinner/Spinner";

const pageNumber = withState("pageNumber", "setPageNumber", 0);

const loading = withState("loading", "setLoading", false);

const handlers = withHandlers({
  handleScroll: ({
    loadMore,
    setPageNumber,
    setLoading,
    pageNumber,
    dataLength,
    dataMaxLength,
    loading
  }) => () => {
    if (dataLength > 0 && dataMaxLength > dataLength && !loading) {
      setLoading(true);
      loadMore(pageNumber);
    }
  }
});

let ListAutoScroll = ({
  children,
  handleScroll,
  dataLength,
  dataMaxLength
}) => {
  // console.log("dataLength, dataMaxLength", dataLength, dataMaxLength)
  handleScroll();
  return (
    <div>
      {/* {dataMaxLength > dataLength ? (
        <div>
          <Spinner size="sm" />
        </div>
      ) : (
        <div />
      )} */}
      {children}
      {/* <Observer onChange={() => handleScroll()} > */}
      {dataMaxLength > dataLength ? (
        <div>
          <Spinner size="sm" />
        </div>
      ) : (
        <div />
      )}
      {/* </Observer> */}
    </div>
  );
};

ListAutoScroll = lifecycle({
  componentDidUpdate(prevProps) {
    // componentDidUpdate(prevProps) {
    if (this.props.dataLength > prevProps.dataLength) {
      this.props.setPageNumber(this.props.pageNumber + 1);
      this.props.setLoading(false);
    }
    if (this.props.identifier !== prevProps.identifier) {
      this.props.setPageNumber(0);
    }
  }
})(ListAutoScroll);

export default compose(
  pageNumber,
  loading,
  handlers,
  pure
)(ListAutoScroll);
